import React from 'react';
// import './Panel.css'; 
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';



const WineryPanel = ({ closePanel, closeSidebarMenu, className = '' }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleLinkClick = (WineryProducts) => {
    closePanel(); 
    if (closeSidebarMenu) {
      closeSidebarMenu(); // Optionally close sidebar menu
    }
    navigate('/WineryProducts', { state: { WineryProducts } }); // Navigate to /Product with product name as state
  };

  return (
    <div className={`parent-panel ${className}`}>
      <div className="panel">
        <div className="Panel-item" onClick={() => handleLinkClick('BIO Products')}>{t('BIO Products')}</div>
        <div className="Panel-item" onClick={() => handleLinkClick('Clarifiers')}>{t('Clarifiers')}</div>
        <div className="Panel-item" onClick={() => handleLinkClick('Enzymes')}>{t('Enzymes')}</div>
        <div className="Panel-item" onClick={() => handleLinkClick('Oak Alternatives')}>{t('Oak Alternatives')}</div>
        <div className="Panel-item" onClick={() => handleLinkClick('Post Fermentation Development')}>{t('Post Fermentation Development')}</div>
        <div className="Panel-item" onClick={() => handleLinkClick('Tannins')}>{t('Tannins')}</div>
        <div className="Panel-item" onClick={() => handleLinkClick('Yeast')}>{t('Yeast')}</div>
        <div className="Panel-item" onClick={() => handleLinkClick('Yeast Nutrients')}>{t('Yeast Nutrients')}</div>
      </div>
    </div>
  );
};

export default WineryPanel;
